import { suggestionSelected } from '../actions/publicActions';
import getScenarioStore from '../selectors/getScenarioStore';
import SearchScenarioId from '../store/schema/SearchScenarioId';
import { logUsage } from 'owa-analytics-actions';
import { SuggestionKind } from 'owa-search-service';
import { orchestrator } from 'satcheljs';
import { getAggregationBucket } from 'owa-analytics-actions';

export default orchestrator(suggestionSelected, actionMessage => {
    const { suggestion, actionSource, scenarioId, index } = actionMessage;

    logUsage('Search_SuggestionSelected', [
        SearchScenarioId[scenarioId],
        SuggestionKind[suggestion.kind],
        index,
        actionSource,
        getAggregationBucket({
            value: getScenarioStore(scenarioId).searchTextForSuggestion.length,
        }),
    ]);
});
